export enum WalletTypes {
    BEP20 = 'usdt_bep20',
    TON = 'usdt_ton'
}
